import { createClient } from '@supabase/supabase-js'
import type { Database } from '@/types/database'
import { getSupabaseUrl_M12_2, getSupabaseAnonKey_M12_3 } from './constants'

/** Typed Supabase client — M12_5 */
export const supabase = createClient<Database>(
  getSupabaseUrl_M12_2(),
  getSupabaseAnonKey_M12_3()
)
